// extracted by mini-css-extract-plugin
module.exports = {"detail":"EventInfo_detail__9iWfa","item":"EventInfo_item__RzlyW"};